import { useEffect, useState } from "react";
import getFirebase from "../../firebaseConfig";

/**
 * Custom hook to initialize Firebase
 * This hook has been updated to work with Firebase v11
 * It initializes Firebase and returns the Firebase app instance
 */
export default function useFirebase() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    // Initialize Firebase
    const app = getFirebase();
    if (app) {
      setInitialized(true);
    }
  }, []);

  return initialized;
}
